import { createContext } from 'react';
import { AdditionalOfferStore } from '@gp/offer';

const defaultValue: any = {};
export const AdditionalOfferStoreContext = createContext<AdditionalOfferStore>(defaultValue);